import { Component, OnInit, ViewChild, Input } from '@angular/core';
import { ViewMode } from '@common/models/view-mode';
import { CommonService } from '@common/services/common.service';
import { VesselVisitDocumentTypeCodes } from '@common/classes/vessel-visit-document-types';
import { VesselVisitDocumentStatusCodes } from '@common/classes/vessel-visit-document-status-codes';

@Component({
    selector: 'app-accommodation-request-segment',
    templateUrl: './accommodation-request-segment.component.html',
    styleUrls: ['./accommodation-request-segment.component.scss'],
    providers: [CommonService]
})
export class AccommodationRequestSegment implements OnInit {
    @Input() model: any;
    @Input() editMode: boolean;

    VesselVisitDocumentTypeCodes = VesselVisitDocumentTypeCodes;

    accommodationRequest: any

    ngOnInit(): void {
        if(this.model.documentTypeId==VesselVisitDocumentTypeCodes.AR)
            this.accommodationRequest = this.model.accommodationRequests[0];
        else if(this.model.documentTypeId === VesselVisitDocumentTypeCodes.OP)
            this.accommodationRequest = this.model.operationalPlans[0]?.accommodationRequest;
    }      

    get vesselAgency(): number | null {
        return this.accommodationRequest?.vesselAgencyId;
    }

    set vesselAgency(value: number | null) {
        if (this.accommodationRequest!=null) {
            this.accommodationRequest.vesselAgencyId = value;
        }
    }

    get captain(): string | null {
        return this.accommodationRequest?.captain;
    }

    set captain(value: string | null) {
        if (this.accommodationRequest!=null) {
            this.accommodationRequest.captain = value;
        }
    }

    get berth(): number | null {
        const proposals = this.accommodationRequest?.berthProposals;
        if (!proposals?.length) return null;

        const approvedProposal = proposals.find(p => p.accepted === true || p.accepted === 1);

        return approvedProposal?.berthId ?? null;
    }

    set berth(value: number | null) {
        const proposals = this.accommodationRequest?.berthProposals;
        if (!proposals?.length) return;

        // 1️⃣ Reset all to not accepted
        proposals.forEach(p => p.accepted = false);

        // 2️⃣ If null, we just cleared selection
        if (value == null) return;

        // 3️⃣ Find proposal with matching berthId
        const selectedProposal = proposals.find(p => p.berthId === value);

        if (selectedProposal) {
            selectedProposal.accepted = true;
        }
    }

    isRequired(field: string): boolean {  
        if (!this.editMode) {
            return false;
        }
        
        switch(field){
            case 'vesselAgency':
                if(this.model.documentTypeId===VesselVisitDocumentTypeCodes.AR)
                    return true;
                break;
            case 'captain':
                if(this.model.documentTypeId===VesselVisitDocumentTypeCodes.AR)
                    return true;
                break;
        }

        return false;        
    }

    isDisabled(field: string): boolean {
        if (!this.editMode) {
            return true;
        }

        switch(field){
            case 'vesselAgency':
                if(this.model.documentTypeId===VesselVisitDocumentTypeCodes.AR && this.model.statusId ===VesselVisitDocumentStatusCodes.InProgress)
                    return false;
                break;
            case 'captain':
                if(this.model.documentTypeId===VesselVisitDocumentTypeCodes.AR && this.model.statusId ===VesselVisitDocumentStatusCodes.InProgress)
                    return false;
                break;
        }

        return true;        
    }
}
